<template>
  <Dialog v-model:visible="showAddModal" class="w-3/4 bg-white shadow rounded-xl" :modal="true" style="position:relative">
    <loading :active="showSelectPostDialogMyside"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <template #header>
      <div class="w-full text-gray-900 font-semibold">
        {{lang['components']['Event']['AddMaterial']['title']}}
      </div>
    </template>
    <div class="flex flex-wrap mb-2">
      <div class="w-full flex-1 bg-white rounded-xl space-y-6 p-6">
        <div>
          <span class="text-red-500">*</span>
          <span class="text-grap-700 align-middle">{{lang['components']['Event']['AddMaterial']['block_name']}}</span>
          <i
            class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
            v-tooltip="`${lang['components']['Event']['AddMaterial']['block_info']}`"
          ></i>
        </div>
        <!-- <div class="flex-1 space-y-4 tab"> -->
        <div class="flex-1 space-y-4 tab overflow-hidden">
          <div class="flex scrollbar-x">
            <div
              class="flex px-4 py-2 cursor-pointer bg-gray-100 whitespace-nowrap"
              :class="{
                'bg-yellow-300 text-blue-700': currentTab === index
              }"
              v-for="(item, index) in items"
              :key="index"
              @click="adContent(index)"
            >
              <p v-if="!item.isEdit" class="flex-none truncate w-20">
                {{ item.title ? item.title : lang['components']['Event']['AddMaterial']['ad_name'] }}
              </p>

              <input
                v-if="item.isEdit"
                :disabled="editPageType && returnCampaignObjectiveData != 'LEAD_GENERATION'"
                v-model="item.title"
                class="p-inputtext p-component py-0 w-40 underline-box border-show bg-transparent"
                type="text"
                :placeholder="lang['components']['Event']['AddMaterial']['ad_name_placeholder']"
                v-on:keyup="isChangeData()"
              />
              <i
                v-if="currentTab === index"
                @click="item.isEdit = !item.isEdit"
                class="pi pi-pencil mt-2 ml-2"
                style="fontSize: 0.8rem"
              ></i>
            </div>
            <div class="px-4 py-2 cursor-pointer" @click="addItem()">
              <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
            </div>
          </div>
          <!-- <div class="flex text-gray-500">
            <div
              class="px-4 py-2 cursor-pointer bg-gray-100"
              :class="{
                'bg-yellow-300': currentTab === index
              }"
              v-for="(item, index) in items"
              :key="index"
              @click="adContent(index)"
            >
              <span v-if="!item.isEdit">{{ item.title }}</span>

              <input
                v-if="item.isEdit"
                v-model="item.title"
                class="p-inputtext p-component py-0 w-40 underline-box border-show bg-transparent"
                type="text"
                placeholder="廣告"
              />
              <i
                v-if="currentTab === index"
                @click="item.isEdit = !item.isEdit"
                class="pi pi-pencil ml-2"
                style="fontSize: 0.8rem"
              ></i>
            </div>
            <div class="px-4 py-2 cursor-pointer" @click="addItem()">
              <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
            </div>
          </div> -->
          <TabView v-model:activeIndex="currentTab">
            <template v-for="(item, index) in items" :key="index">
              <TabPanel>
                <template #hearder>
                  <div></div>
                </template>
                <div class="space-y-2 pb-8 my-4">
                  <div>
                    <!-- <span class="text-red-500">*</span> -->
                    <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['AddMaterial']['format_info']}}</span>
                    <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="'格式'"></i> -->
                  </div>
                  <div>
                    <button
                      class="text-sm border border-blue-700 hover:bg-blue-700 hover:text-white rounded-md px-4 py-1"
                      :class="[
                        item.type == 1 ? 'bg-blue-700' : 'bg-white',
                        item.type == 1 ? 'text-white' : 'text-blue-700'
                      ]"
                      @click="changeType(index, 1)"
                    >
                      <i class="pi pi-image mr-3" style="fontSize: 0.8rem"></i>
                      <span v-if="this.goalsObjectiveData != 'VIDEO_VIEWS'">{{lang['components']['Event']['AddMaterial']['single_material']}}</span>
                      <span v-if="this.goalsObjectiveData == 'VIDEO_VIEWS'">{{lang['components']['Event']['AddMaterial']['single_video_material']}}</span>
                    </button>
                    <button
                      v-if="this.goalsObjectiveData != 'VIDEO_VIEWS' && this.goalsObjectiveData != 'POST_ENGAGEMENT'"
                      class="text-sm border border-blue-700 hover:bg-blue-700 hover:text-white rounded-md px-4 py-1 ml-4"
                      :class="[
                        item.type == 2 ? 'bg-blue-700' : 'bg-white',
                        item.type == 2 ? 'text-white' : 'text-blue-700'
                      ]"
                      @click="changeType(index, 2)"
                    >
                      <i class="pi pi-images" style="fontSize: 0.8rem"></i>
                      {{lang['components']['Event']['AddMaterial']['carousel_material']}}
                    </button>
                    <button
                      class="text-sm border border-blue-400 text-blue-400 rounded-md px-4 py-1 ml-4 float-right"
                      @click="removeAd(index)"
                    >
                      {{lang['components']['Event']['AddMaterial']['delete_material']}}
                    </button>
                  </div>
                  <hr />
                </div>
                <div class="space-y-2 pb-8 my-4" v-if="item.type == 1" style="position:relative">
                  <loading :active="!showMaterialSingle"
                          :can-cancel="true"
                          :on-cancel="onCancel"
                          :is-full-page="false"
                          :color="'#fff'"
                          :background-color="'#000'"
                          :opacity="'0.8'"
                          :loader=" dots">
                  </loading>
                  <div>
                    <!-- <span class="text-red-500">*</span> -->
                    <span class="text-grap-700 align-middle text-sm"
                      >{{lang['components']['Event']['AddMaterial']['material_setting']}}</span
                    >
                    <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="'格式'"></i> -->
                  </div>
                  <div>
                    <button
                      v-on:click="getImageVideoList(item.type, 0)"
                      class="text-sm border border-blue-700 bg-blue-700 text-white rounded-md px-4 py-1"
                      v-if="item.materialSingle.length == 0"
                    >
                      <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
                      {{lang['components']['Event']['AddMaterial']['add_material']}}
                    </button>
                    <div
                      v-for="(itemSingle, i) in item.materialSingle"
                      :key="i"
                      class="flex justify-between bg-gray-100 rounded-xl border overflow-hidden p-1 w-full hover:border-grap-400 mt-4"
                    >
                      <div class="flex p-1">
                        <div class="md:flex-shrink-0">
                          <img
                            class="h-24 w-24 rounded-xl object-cover"
                            :src="itemSingle.imgSrc"
                          />
                        </div>
                        <div class="mx-8">
                          <p class="text-gray-800 text-sm">
                            {{ itemSingle.fileName ? itemSingle.fileName : "" }}
                            <template v-for="(_tmp_object_spec, obj_index) in itemSingle.object_spec">
                              <template v-if="obj_index == 'type' && _tmp_object_spec == 'image'">
                                {{lang['components']['Event']['AddMaterial']['material_type_image']}}
                              </template>
                              <template v-if="obj_index == 'type' && _tmp_object_spec == 'video'">
                                {{lang['components']['Event']['AddMaterial']['material_type_video']}}
                              </template>
                            </template>
                          </p>
                          <p class="text-gray-500 text-sm">{{ itemSingle.size }}</p>
                          <button
                            class="text-sm border border-blue-400 text-blue-400 rounded-md px-4 py-1 mt-4"
                            v-on:click="getImageVideoList(item.type, 0)"
                          >
                            {{lang['components']['Event']['AddMaterial']['change_material']}}
                          </button>
                          <button
                            class="text-sm border border-blue-400 text-blue-400 rounded-md px-4 py-1 mt-4 ml-4"
                            v-on:click="editAiPicture"
                          >
                            AI圖片生成
                          </button>
                        </div>
                      </div>
                      <!-- <i class="pi pi-times cursor-pointer text-right m-2"></i> -->
                    </div>
                  </div>
                </div>
                <div class="space-y-2 pb-8 my-4" v-if="item.type == 2">
                  <div>
                    <!-- <span class="text-red-500">*</span> -->
                    <span class="text-grap-700 align-middle text-sm"
                      >{{lang['components']['Event']['AddMaterial']['carousel_card']}}</span
                    >
                    <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="'格式'"></i> -->
                  </div>
                  <div>
                    <draggable
                      v-if="item.materials.length"
                      v-model="item.materials"
                      :disabled="isEdit"
                      @start="drag = true"
                      @end="drag = false"
                      item-key="id"
                    >
                      <template #item="{ element }" >
                        <div
                          class="bg-white bg-blue-100 rounded-xl border overflow-hidden p-4 w-full hover:border-grap-400 mt-4 space-y-2"
                        >
                          <div class="flex justify-between ">
                            <div class="flex p-1">
                              <div class="my-auto -ml-2">
                                <i
                                  class="pi pi-ellipsis-v"
                                  style="fontSize: 1.3rem"
                                ></i>
                                <i
                                  class="pi pi-ellipsis-v -ml-2"
                                  style="fontSize: 1.3rem"
                                ></i>
                              </div>
                              <div class="md:flex-shrink-0">
                                <img
                                  class="h-24 w-24 rounded-xl object-cover cursor-pointer"
                                  v-if="element.imgSrc"
                                  :src="element.imgSrc"
                                  @click="element.isEdit = !element.isEdit"
                                />
                                <div
                                  v-else
                                  class="h-24 w-24 rounded-xl border cursor-pointer border-gray-400 text-center"
                                  @click="element.isEdit = !element.isEdit"
                                >
                                  <i
                                    class="pi pi-plus my-7"
                                    style="fontSize: 2rem"
                                  ></i>
                                </div>
                              </div>
                              <div class="mx-8 my-auto">
                                <p class="text-gray-800 text-sm">
                                  <template v-if="element.object_spec.title != ''">
                                    {{element.object_spec.title}}
                                  </template>
                                  <template v-if="element.object_spec.name != ''">
                                    {{element.object_spec.name}}
                                  </template>
                                  <template v-if="element.object_spec.type == 'image'">
                                    {{lang['components']['Event']['AddMaterial']['material_type_image']}}
                                  </template>
                                  <template v-if="element.object_spec.type == 'video'">
                                    {{lang['components']['Event']['AddMaterial']['material_type_video']}}
                                  </template>
                                </p>
                                <p class="text-gray-500 text-sm">
                                  <span v-if="element.title != ''" class="truncate w-20">
                                    {{ element.title }}
                                  </span>
                                  <span v-if="element.title == ''" class="w-20">
                                    {{lang['components']['Event']['AddMaterial']['not_title']}}
                                  </span>
                                   -
                                   <span v-if="element.description != ''" class="truncate w-20">
                                    {{ element.description }}
                                  </span>
                                  <span v-if="element.description == ''" class="w-20">
                                    {{lang['components']['Event']['AddMaterial']['not_description']}}
                                  </span>
                                   -
                                   <span v-if="element.website != ''" class="truncate w-20">
                                    {{ element.website }}
                                  </span>
                                  <span v-if="element.website == ''" class="w-20">
                                    {{lang['components']['Event']['AddMaterial']['not_website']}}
                                  </span>
                                </p>
                              </div>
                            </div>
                            <div class="flex flex-col">
                              <i
                                v-if="item.materials.length > 2"
                                class="pi pi-times cursor-pointer text-right m-2"
                                @click="removeItem(currentTab, element.index)"
                              ></i>
                              <i
                                class="pi cursor-pointer my-auto text-right mx-2 text-blue-400"
                                :class="[element.isEdit ? 'pi-angle-up' : 'pi-pencil']"
                                style="fontSize: 1.2rem"
                                @click="element.isEdit = !element.isEdit"
                              ></i>
                            </div>
                          </div>
                          <div
                            class="w-full flex-1 bg-white rounded-xl space-y-6 p-6 transition duration-500"
                            v-show="element.isEdit"
                            style="position:relative"
                          >
                          <loading :active="!showMaterial"
                                  :can-cancel="true"
                                  :on-cancel="onCancel"
                                  :is-full-page="false"
                                  :color="'#fff'"
                                  :background-color="'#000'"
                                  :opacity="'0.8'"
                                  :loader=" dots">
                          </loading>
                            <div
                              class="flex justify-between bg-gray-100 rounded-xl border overflow-hidden p-1 w-full hover:border-grap-400 mt-4"
                              v-if="element.imgSrc"
                            >
                              <div class="flex p-1">
                                <div class="md:flex-shrink-0">
                                  <img
                                    class="h-24 w-24 rounded-xl object-cover"
                                    :src="element.imgSrc"
                                  />
                                </div>
                                <div class="mx-8">
                                  <p class="text-gray-800 text-sm">
                                    <template v-if="element.object_spec.title != ''">
                                      {{element.object_spec.title}}
                                    </template>
                                    <template v-if="element.object_spec.name != ''">
                                      {{element.object_spec.name}}
                                    </template>
                                    <template v-if="element.object_spec.type == 'image'">
                                      {{lang['components']['Event']['AddMaterial']['material_type_image']}}
                                    </template>
                                    <template v-if="element.object_spec.type == 'video'">
                                      {{lang['components']['Event']['AddMaterial']['material_type_video']}}
                                    </template>
                                  </p>
                                  <p class="text-gray-500 text-sm">{{element.object_spec.width}}*{{element.object_spec.height}}</p>
                                  <button
                                    class="text-sm border border-blue-400 bg-blue-400 text-white rounded-md px-4 py-1 mt-4"
                                    v-on:click="getImageVideoList(item.type, element.index)"
                                  >
                                    {{lang['components']['Event']['AddMaterial']['change_material']}}
                                  </button>
                                  <button
                                    class="text-sm border border-blue-400 text-blue-400 rounded-md px-4 py-1 mt-4 ml-4"
                                    v-on:click="editAiPicture"
                                  >
                                    AI圖片生成
                                  </button>
                                </div>
                              </div>
                              <i
                                v-if="false"
                                class="pi pi-times cursor-pointer text-right m-2"
                                @click="removeItem(currentTab, element.index)"
                              ></i>
                            </div>
                            <div v-else>
                              <button
                                v-on:click="getImageVideoList(item.type, element.index)"
                                class="text-sm border border-blue-700 bg-blue-700 text-white rounded-md px-4 py-1"
                              >
                                <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
                                {{lang['components']['Event']['AddMaterial']['add_material']}}
                              </button>
                              <button
                                class="text-sm border border-blue-400 text-blue-400 rounded-md px-4 py-1 mt-4 ml-4"
                                v-on:click="editAiPicture"
                              >
                                AI圖片生成
                              </button>
                            </div>
                            <div>
                              <span class="text-grap-700 align-middle text-sm"
                                >{{lang['components']['Event']['AddMaterial']['material_title']}}</span
                              >
                              <button
                                v-if="formActive == 'customize'"
                                class="text-sm border border-blue-400 text-blue-400 rounded-md px-2 ml-2"
                                @click="useAi($event, 'carousel_title', index, element.index)"
                              >
                                AI生成
                              </button>
                              <input
                                class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                                type="text"
                                :placeholder="lang['components']['Event']['AddMaterial']['material_title_placeholder']"
                                :disabled="editPageType"
                                v-model="element.title"
                                v-on:keyup="isChangeData()"
                                v-on:focus="lock()"
                                v-on:blur="unlock()"
                              />
                            </div>
                            <div>
                              <span class="text-grap-700 align-middle text-sm"
                                >{{lang['components']['Event']['AddMaterial']['material_description']}}</span
                              >
                              <button
                                v-if="formActive == 'customize'"
                                class="text-sm border border-blue-400 text-blue-400 rounded-md px-2 ml-2"
                                @click="useAi($event, 'carousel_description', index, element.index)"
                              >
                                AI生成
                              </button>
                              <input
                                class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                                type="text"
                                :placeholder="lang['components']['Event']['AddMaterial']['material_description_placeholder']"
                                :disabled="editPageType"
                                v-model="element.description"
                                v-on:keyup="isChangeData()"
                                v-on:focus="lock()"
                                v-on:blur="unlock()"
                              />
                            </div>
                            <div>
                              <span class="text-grap-700 align-middle text-sm"
                                >{{lang['components']['Event']['AddMaterial']['material_website']}}</span
                              >
                              <input
                                class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                                type="text"
                                :placeholder="lang['components']['Event']['AddMaterial']['material_website_placeholder']"
                                :disabled="editPageType"
                                v-model="element.website"
                                v-on:keyup="isChangeData()"
                                v-on:focus="lock()"
                                v-on:blur="unlock()"
                              />
                            </div>
                          </div>
                        </div>
                      </template>
                    </draggable>

                    <!-- <div
                      class="bg-white bg-blue-100 rounded-xl border overflow-hidden p-4 w-full hover:border-grap-400 mt-4 space-y-2"
                      v-for="(material, materIndex) in item.materials"
                      :key="materIndex"
                    >
                      <div class="flex justify-between ">
                        <div class="flex p-1">
                          <div class="my-auto -ml-2">
                            <i
                              class="pi pi-ellipsis-v"
                              style="fontSize: 1.3rem"
                            ></i>
                            <i
                              class="pi pi-ellipsis-v -ml-2"
                              style="fontSize: 1.3rem"
                            ></i>
                          </div>
                          <div class="md:flex-shrink-0">
                            <img
                              class="h-24 w-24 rounded-xl object-cover cursor-pointer"
                              v-if="material.imgSrc"
                              :src="material.imgSrc"
                            />
                            <div
                              v-else
                              class="h-24 w-24 rounded-xl border cursor-pointer border-gray-400 text-center"
                            >
                              <i
                                class="pi pi-plus my-7"
                                style="fontSize: 2rem"
                              ></i>
                            </div>
                          </div>
                          <div class="mx-8 my-auto">
                            <p class="text-gray-800 text-sm">Untitled</p>
                            <p class="text-gray-500 text-sm">
                              標題：{{ material.title }}
                            </p>
                          </div>
                        </div>
                        <i
                          class="pi cursor-pointer my-auto text-right mx-2"
                          :class="[material.isEdit ? 'pi-angle-up' : 'pi-pencil']"
                          style="fontSize: 1.2rem"
                          @click="material.isEdit = !material.isEdit"
                        ></i>
                      </div>
                      <div
                        class="w-full flex-1 bg-white rounded-xl space-y-6 p-6 transition duration-500"
                        v-show="material.isEdit"
                      >
                        <div
                          class="flex justify-between bg-gray-100 rounded-xl border overflow-hidden p-1 w-full hover:border-grap-400 mt-4"
                          v-if="material.imgSrc"
                        >
                          <div class="flex p-1">
                            <div class="md:flex-shrink-0">
                              <img
                                class="h-24 w-24 rounded-xl object-cover"
                                :src="material.imgSrc"
                              />
                            </div>
                            <div class="mx-8">
                              <p class="text-gray-800 text-sm">Untitled</p>
                              <p class="text-gray-500 text-sm">800*800</p>
                              <button
                                class="text-sm border border-blue-700 bg-blue-700 text-white rounded-md px-4 py-1 mt-4"
                                v-on:click="getImageVideoList(item.type, materIndex)"
                              >
                                更換素材
                              </button>
                            </div>
                          </div>
                          <i
                            class="pi pi-times cursor-pointer text-right m-2"
                          ></i>
                        </div>
                        <button
                          v-on:click="getImageVideoList(item.type, materIndex)"
                          class="text-sm border border-blue-700 bg-blue-700 text-white rounded-md px-4 py-1"
                          v-else
                        >
                          <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
                          新增影音素材
                        </button>
                        <div>
                          <span class="text-grap-700 align-middle text-sm"
                            >標題</span
                          >
                          <input
                            class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                            type="text"
                            placeholder="請輸入標題"
                            v-model="material.title"
                          />
                        </div>
                        <div>
                          <span class="text-grap-700 align-middle text-sm"
                            >說明</span
                          >
                          <input
                            class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                            type="text"
                            placeholder="請輸入說明"
                            v-model="material.description"
                          />
                        </div>
                        <div>
                          <span class="text-grap-700 align-middle text-sm"
                            >網站網址</span
                          >
                          <input
                            class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                            type="text"
                            placeholder="請輸入網站網址"
                            v-model="material.website"
                          />
                        </div>
                      </div>
                    </div> -->
                    <button
                      class="text-sm border border-blue-400 text-blue-400 rounded-md px-4 py-1 mt-4"
                      @click="addMaterials(index)"
                    >
                      {{lang['components']['Event']['AddMaterial']['add_carousel_card']}}
                    </button>
                    <label class="inline-flex items-center mt-3 w-full" v-if="item.type == 2">
                      <input type="checkbox" :disabled="editPageType" v-model="item.multi_share_optimized" v-on:change="isChangeData()"/>
                      <span class="ml-2 text-gray-700 text-sm"
                        >{{lang['components']['Event']['AddMaterial']['multi_share_optimized_text']}}</span
                      >
                    </label>
                  </div>
                </div>
                <div class="space-y-2 pb-8 my-4">
                  <label class="inline-flex items-center mt-3 w-full" v-if="item.type == 1 && this.goalsObjectiveData == 'VIDEO_VIEWS'">
                    <input type="checkbox" :disabled="editPageType" v-model="item.videoIsRequired"/>
                    <span class="ml-2 text-gray-700 text-sm"
                      >{{lang['components']['Event']['AddMaterial']['carousel_website']}}</span
                    >
                  </label>
                  <div>
                    <span class="text-grap-700 align-middle text-sm"
                      v-if="item.type == 1"
                      >{{lang['components']['Event']['AddMaterial']['material_message_type_1']}}</span
                    >
                    <span class="text-grap-700 align-middle text-sm"
                      v-if="item.type == 2"
                      >{{lang['components']['Event']['AddMaterial']['material_message_type_2']}}</span
                    >
                    <button
                      v-if="formActive == 'customize'"
                      class="text-sm border border-blue-400 text-blue-400 rounded-md px-2 ml-2"
                      @click="useAi($event, 'single_message', index, '')"
                    >
                      AI生成
                    </button>
                    <textarea
                      class="w-full h-24 px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      :placeholder="lang['components']['Event']['AddMaterial']['material_message_placeholder']"
                      :disabled="editPageType"
                      v-model="item.message"
                      v-on:keyup="isChangeData()"
                    ></textarea>
                  </div>
                  <div v-if="item.type == 1 && item.videoIsRequired">
                    <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['AddMaterial']['material_single_title']}}</span>
                    <button
                      v-if="formActive == 'customize'"
                      class="text-sm border border-blue-400 text-blue-400 rounded-md px-2 ml-2"
                      @click="useAi($event, 'single_title', index, '')"
                    >
                      AI生成
                    </button>
                    <input
                      class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      :placeholder="lang['components']['Event']['AddMaterial']['material_single_title_placeholder']"
                      :disabled="editPageType"
                      v-model="item.materialSingle[0].title"
                      v-on:keyup="isChangeData()"
                    />
                  </div>
                  <div v-if="item.type == 1 && item.videoIsRequired">
                    <span v-if="this.goalsObjectiveData != 'VIDEO_VIEWS'" class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['AddMaterial']['material_single_not_video_description']}}</span>
                    <span v-if="this.goalsObjectiveData == 'VIDEO_VIEWS'" class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['AddMaterial']['material_single_is_video_description']}}</span>
                    <!-- <button
                      v-if="formActive == 'customize'"
                      class="text-sm border border-blue-400 text-blue-400 rounded-md px-2 ml-2"
                      @click="useAi($event, 'single_description', index, '')"
                    >
                      AI生成
                    </button> -->
                    <textarea
                      class="w-full h-24 px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      :placeholder="lang['components']['Event']['AddMaterial']['material_single_description_placeholder']"
                      :disabled="editPageType"
                      v-model="item.materialSingle[0].description"
                      v-on:keyup="isChangeData()"
                    ></textarea>
                  </div>
                  <div v-if="item.type == 1 && item.videoIsRequired">
                    <span v-if="this.goalsObjectiveData != 'VIDEO_VIEWS'" class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['AddMaterial']['item_not_video_link']}}</span>
                    <span v-if="this.goalsObjectiveData == 'VIDEO_VIEWS'" class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['AddMaterial']['item_is_video_link']}}</span>
                    <input
                      class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      :placeholder="lang['components']['Event']['AddMaterial']['item_link_placeholder']"
                      :disabled="editPageType"
                      v-model="item.link"
                      v-on:keyup="isChangeData()"
                    >
                  </div>
                  <div v-if="item.type == 1 && item.videoIsRequired">
                    <span v-if="this.goalsObjectiveData != 'VIDEO_VIEWS'" class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['AddMaterial']['item_not_video_caption']}}</span>
                    <span v-if="this.goalsObjectiveData == 'VIDEO_VIEWS'" class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['AddMaterial']['item_is_video_caption']}}</span>
                    <input
                      class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      :placeholder="lang['components']['Event']['AddMaterial']['item_caption_placeholder']"
                      :disabled="editPageType"
                      v-model="item.caption"
                      v-on:keyup="isChangeData()"
                    >
                  </div>
                </div>
                <!-- <div
                  class="text-sm text-blue-300 underline cursor-pointer"
                  @click="moreInput = !moreInput"
                >
                  {{ moreWording }}更多選項
                  <i
                    class="pi"
                    :class="[moreInput ? 'pi-caret-up' : 'pi-caret-down']"
                    style="fontSize: 0.8rem"
                  ></i>
                </div> -->
                <!-- <div class="space-y-2 pb-8 my-4" v-show="moreInput"> -->
                <div v-if="item.videoIsRequired" class="space-y-2 pb-8 my-4">
                  <div class="flex flex-col">
                    <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['AddMaterial']['call_active_text']}}</span>
                    <Dropdown
                      :disabled="editPageType"
                      v-model="item.callActive"
                      optionLabel="name"
                      optionValue="code"
                      :options="callActiveList[this.goalsObjectiveData]"
                      :placeholder="lang['components']['Event']['AddMaterial']['call_active_placeholder']"
                      v-on:change="isChangeData()"
                      class="w-1/3 rounded-md"
                    />
                  </div>
                </div>
              </TabPanel>
            </template>
          </TabView>
        </div>
      </div>

      <div class="w-1/4 rounded-xl space-y-2 px-4" style="width:425px;">
        <div class="flex flex-col bg-white rounded-xl space-y-2 p-4">
          <div v-html="prview_now" v-if="prview_now"></div>
          <div v-html="prview_single" v-if="prview_single"></div>
        </div>
      </div>

      <!-- <div class="w-1/4 rounded-xl space-y-2 px-4">
        <div class="flex flex-col bg-white rounded-xl space-y-2 p-4">
          <div class="flex justify-between">
            <span class="text-gray-700">預覽</span>
            <div class="bg-gray-500 text-white rounded-xl">
              <a href="javascript:void(0);"
                ><i class="pi pi-angle-left mx-2"></i
              ></a>
              <a href="javascript:void(0);"
                ><i class="pi pi-angle-right mx-2"></i
              ></a>
            </div>
          </div>
          <hr class="-mx-4" />
          <div class="overflow-hidden w-full">
            <div class="flex">
              <div class="md:flex-shrink-0">
                <img
                  class="h-8 w-8 rounded-2xl object-cover"
                  src="http://placehold.it/100x100"
                />
              </div>
              <div class="mx-2">
                <p class="text-gray-800 text-xs">寓意科技</p>
                <p class="text-gray-500 text-xs">
                  <img :src="fb1Image" class="h-3" />
                </p>
              </div>
              <i
                class="pi pi-ellipsis-h m-auto w-1/3 text-right"
                style="fontSize: 0.8rem"
              ></i>
            </div>
          </div>
          <div class="text-sm">貼文內容貼文內容貼文內容</div>
          <div class="border-b border-gray-400">
            <img src="http://placehold.it/800x600" class="w-full" />
            <div class="flex justify-between bg-gray-200 p-2">
              <div>
                <p class="text-gray-800 text-xs">EXAMPLE.COM</p>
                <p class="text-gray-500 text-xs">標題</p>
              </div>
              <button
                class="text-xs border border-gray-400 text-gray-400 rounded-md h-6"
              >
                發送訊息
              </button>
            </div>
          </div>
          <img :src="fb2Image" alt="" />
        </div>
      </div> -->

      <!-- <ModifyWindows v-model:show="showVideoWindows" size="sm"> -->
      <div v-if="view_ai">
        <Vue3DraggableResizable
          :initW="400"
          :initH="auto"
          v-model:x="ai_x"
          v-model:y="ai_y"
          v-model:w="ai_w"
          v-model:h="ai_h"
          v-model:active="active"
          :draggable="true"
          :resizable="false"
          class="rounded-md cursor-move"
          style="background-color: #fff; border:1px #D1D5DB solid; z-index:2000;"
        >
          <div class="text-white p-2 rounded-t-md" style="background-color:#1D619F;">
            生成文案
            <i v-if="aiContentProcessing == false" class="pi pi-times text-white cursor-pointer float-right" style="position: absolute; right:10px; top: 10px;" @click="view_ai = !view_ai"></i>
          </div>
          <div :class="[aiContentReturn.length > 0 ? null : 'rounded-b-md pb-3']" style="background-color:#CBD4DD;">
            <div v-if="formTarget != '' && formTarget != null" class="text-sm px-3 pt-3">
              {{formTarget}}
            </div>
            <div class="ml-3 mt-3 mr-3 text-right bg-white rounded-md" :class="[aiContentReturn.length > 0 ? 'pb-3' : null]">
              <textarea
                class="w-full h-32 p-3 text-sm leading-tight text-gray-500 rounded-md appearance-none focus:outline-none focus:shadow-outline"
                type="text"
                placeholder="請輸入要產生的文案大綱"
                style="resize: none;"
                v-model="aiWord"
              ></textarea>
              <button class="text-white px-3 py-1 mx-3 rounded-md" :class="[aiContentReturn.length > 0 ? null : 'mb-3']" style="background-color:#1D619F;" @click="generateCopy">
                {{processText}}
              </button>
            </div>
          </div>
          <div v-if="aiContentReturn.length > 0" class="p-3" style="background-color:#CBD4DD;">
            <div class="p-2 rounded-md overflow-y-auto" style="background-color:#E2EBF2; max-height:200px;">
              <template v-for="(item, index) in aiContentReturn" :key="item.index">
                <label class="block grid grid-cols-12 mb-3" :for="'radio-' + index">
                  <input
                    type="radio"
                    :id="'radio-' + index"
                    class="form-radio h-5 w-5 text-blue-600"
                    :disabled="editPageType"
                    :value="index"
                    v-model="itemCheckedIndex"
                    @click="itemCheckedIndex = index"
                  />
                  <span class="break-all col-span-11">{{item.content}}</span>
                </label>
              </template>
            </div>
          </div>
          <div v-if="aiContentReturn.length > 0" class="text-right h-10 rounded-b-md px-3" style="background-color:#CBD4DD;">
            <div class="float-left text-sm leading-8">
              選擇滿意的文案，即可加入欄位
            </div>
            <button v-if="aiContentProcessing != true" class="text-gray-500 px-3 py-1 rounded-md" style="background-color:#F2F2F2;" @click="view_ai = !view_ai">
              取消
            </button>
            <button v-if="itemCheckedIndex != null" class="text-white px-3 py-1 ml-3 rounded-md" style="background-color:#1D619F;" @click="setAiContent">
              確定
            </button>
          </div>
        </Vue3DraggableResizable>
      </div>
      <ModifyWindows v-model:show="showVideoWindows">
        <template v-slot:header>
          <span class="mr-2 text-2xl font-semibold align-sub">{{lang['components']['Event']['AddMaterial']['material_block_title']}}</span>
          <button @click="materialUpdate()" class="button border-blue">
            {{lang['components']['Event']['AddMaterial']['material_block_update']}}
          </button>
          <!-- <button @click="$refs.imageUpload.click()" class="ml-2 button border-blue">
            <img
              class="mr-2 inline-block align-baseline"
              src="../../assets/upload.svg"
            />
            上傳圖片至廣告帳戶
          </button> -->
          <input type="file" ref="imageUpload" class="hidden" @change="onImageUpload"/>
          <!--{{lang['components']['Event']['AddMaterial']['material_block_title_info']}}-->
          <button @click="showUploadWindows = true" class="ml-2 button border-blue">
            <!-- <img
              class="mr-2 inline-block align-baseline"
              src="../../assets/upload.svg"
            /> -->
            <i
              class="pi pi-image align-middle mb-1"
            ></i>
            上傳圖片至廣告帳戶
          </button>
          <button @click="showUploadVideoWindows = true" class="ml-2 button border-blue">
            <!-- <img
              class="mr-2 inline-block align-baseline"
              src="../../assets/upload.svg"
            /> -->
            <i
              class="pi pi-video align-middle mb-1"
            ></i>
            上傳影片至廣告帳戶
          </button>
          <i
            class="mt-1 ml-2 pi pi-exclamation-circle align-middle text-gray-300"
            v-tooltip="'若列表中不見剛上傳完成的素材，請稍候再按更新。'"
          ></i>
        </template>

        <template v-slot:content>
          <loading :active="!showVideoLoading"
                  :can-cancel="true"
                  :is-full-page="false"
                  :color="'#fff'"
                  :background-color="'#000'"
                  :opacity="'0.8'">
          </loading>
          <div class="flex flex-wrap p-2 w-full h-full scrollbar-y" style="position:relative">
            <div v-if="this.goalsObjectiveData != 'VIDEO_VIEWS'" class="w-full">
               <span class="text-grap-700 align-middle">{{lang['components']['Event']['AddMaterial']['material_block_image']}}</span>
            </div>
            <div
              v-if="this.goalsObjectiveData != 'VIDEO_VIEWS'"
              v-for="(item, i) in image.imageList"
              :key="i"
            >
              <img
                @click="changeSelectedForm(i, 'image')"
                :class="{ 'border-blue-light': image.active == i }"
                :src="image.imageList[i]"
                class="
                  flex-none
                  m-2
                  mb-4
                  w-24
                  h-24
                  border-4 border-transparent
                  object-cover
                  rounded-xl
                  cursor-pointer
                "
                :title="image.imageListTitle[i]"
              />
              <div
                class="text-center -mt-2 w-28"
              >
                {{image.imageListName[i]}}
              </div>
            </div>
            <div v-if="imageAfter != ''" class="w-full mt-4 text-center">
              <button
                class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
                @click="moreImage()"
              >{{lang['components']['Event']['AddMaterial']['material_block_image_more']}}</button>
            </div>
            <div class="w-full border-t-2 mt-20">
               <span class="text-grap-700 align-middle">{{lang['components']['Event']['AddMaterial']['material_block_video']}}</span>
            </div>
            <div
              v-for="(item, i) in video.videoList"
              :key="i"
            >
              <img
                @click="changeSelectedForm(i, 'video')"
                :class="{ 'border-blue-light': video.active == i }"
                :src="video.videoList[i]"
                class="
                  flex-none
                  m-2
                  mb-4
                  w-24
                  h-24
                  border-4 border-transparent
                  object-cover
                  rounded-xl
                  cursor-pointer
                "
                :title="video.videoListTitle[i]"
              />
              <div
                class="text-center -mt-2 w-28"
              >
                {{video.videoListName[i]}}
              </div>
            </div>
            <div v-if="videoAfter != ''" class="w-full mt-4 text-center">
              <button
                class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
                @click="moreVideo()"
              >{{lang['components']['Event']['AddMaterial']['material_block_video_more']}}</button>
            </div>
          </div>
        </template>

        <template v-slot:footer>
          <div class="text-right">
            <button @click="setMaterial(currentTab)" class="button bg-yellow">{{lang['components']['Event']['AddMaterial']['set_material']}}</button>
          </div>
        </template>
      </ModifyWindows>
      <ModifyWindows v-model:show="showUploadWindows" size="md">
        <template v-slot:header>
          上傳圖片至廣告帳戶
        </template>
        <template v-slot:content>
          <div class="upload-multiple-container">
            <div class="actions">
              <button v-show="isUploading == false" class="custom-upload-btn" @click="triggerFileInput">選擇圖片</button>
              <button
                 v-show="selectedFiles.length > 0"
                @click="uploadImages"
                :disabled="isUploading || selectedFiles.length === 0"
                class="upload-btn"
              >
                {{ isUploading ? "上傳中..." : "上傳圖片" }}
              </button>
            </div>
            <input
              type="file"
              multiple
              @change="onFilesSelected"
              ref="fileInput"
              class="hidden"
              accept="image/*"
            />

            <div v-if="selectedFiles.length > 0" class="preview-list">
              <h3 class="subtitle font-bold text-blue-600">準備上傳的圖片</h3>
              <ul>
                <li v-for="(file, index) in selectedFiles" :key="file.name" class="file-item">
                  <img
                    :src="file.previewUrl"
                    alt="預覽"
                    class="preview-image"
                  />
                  <div class="file-info">
                    <span class="file-name">{{ file.name }}</span>
                    <button v-show="isUploading == false" @click="removeFile(index)" class="remove-btn">移除</button>
                  </div>
                </li>
              </ul>
            </div>

            <div v-if="uploadResults.length > 0" class="upload-results">
              <h3 class="subtitle font-bold text-green-600">上傳结果</h3>
              <ul>
                <li v-for="(result, index) in uploadResults" :key="index">
                  <img
                    :src="result.previewUrl"
                    alt="預覽"
                    class="preview-image"
                  />
                  <span>{{ result.fileName }} - </span>
                  <span :style="{ color: result.success ? 'green' : 'red' }">
                    {{ result.success ? "上傳成功" : "上傳失敗" }}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </template>
      </ModifyWindows>

      <ModifyWindows v-model:show="showUploadVideoWindows" size="md">
        <template v-slot:header>
          上傳影片至廣告帳戶
        </template>
        <template v-slot:content>
          <div class="upload-multiple-container">
            <div class="actions">
              <button v-show="videoIsUploading == false && selectedVideoFiles.length === 0" class="custom-upload-btn" @click="triggerFileInputVideo">選擇影片</button>
              <button
                 v-show="selectedVideoFiles.length > 0"
                @click="uploadVideo"
                :disabled="videoIsUploading || selectedVideoFiles.length === 0"
                class="upload-btn"
              >
                {{ videoIsUploading ? "上傳中..." : "上傳影片" }}
              </button>
            </div>
            <input
              type="file"
              @change="onVideoFilesSelected"
              ref="fileVideoInput"
              class="hidden"
              accept="video/mp4"
            />

            <div v-if="selectedVideoFiles.length > 0" class="preview-list">
              <h3 class="subtitle font-bold text-blue-600">準備上傳的影片</h3>
              <ul>
                <li v-for="(file, index) in selectedVideoFiles" :key="file.name" class="file-item">
                  <div class="file-info">
                    <span class="file-name">{{ file.name }}</span>
                    <button v-show="videoIsUploading == false" @click="removeVideoFile(index)" class="remove-btn">移除</button>
                  </div>
                </li>
              </ul>
            </div>

            <div v-if="uploadVideoResults.length > 0" class="upload-results">
              <h3 class="subtitle font-bold text-green-600">上傳结果</h3>
              <ul>
                <li v-for="(result, index) in uploadVideoResults" :key="index">
                  <span>{{ result.fileName }} - </span>
                  <span :style="{ color: result.success ? 'green' : 'red' }">
                    {{ result.success ? "上傳成功" : "上傳失敗" }}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </template>
      </ModifyWindows>
    </div>
    <template #footer>
      <div class="w-full flex flex-wrap justify-end py-4 border-t border-gray-400">
        <button
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-gray-400 transition duration-500 ease-in-out mt-32 border-2"
          @click="showAddModal=false">{{lang['components']['Event']['AddMaterial']['cancel_button']}}</button>
        <button
          class="bg-yellow-400 hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-blue-800 transition duration-500 ease-in-out mt-32 border-2 border-yellow-400"
          style="margin-right:72px;"
          @click="save()">{{lang['components']['Event']['AddMaterial']['save_button']}}</button>
      </div>
    </template>
  </Dialog>
  <AiPictureMaterialDialog v-model:show="showAiPictureModal" />
</template>
<script>
import Dialog from 'primevue/dialog';
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Dropdown from "primevue/dropdown";
import fb1Image from "@/assets/fb_1.png";
import fb2Image from "@/assets/fb_2.png";
import ModifyWindows from "@/components/ModifyWindows.vue";
import AiPictureMaterialDialog from "@/components/Dialog/AiPictureMaterialDialog.vue";
import draggable from "vuedraggable";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import "vue3-circle-progress/dist/circle-progress.css";
import Vue3DraggableResizable from 'vue3-draggable-resizable'
import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'
import axios from 'axios'
import Qs from 'qs'

export default {
  name: "AdvertisingMaterial",
  components: {
    Dialog,
    TabView,
    TabPanel,
    Dropdown,
    ModifyWindows,
    AiPictureMaterialDialog,
    draggable,
    Swal,
    Loading
  },
  props: {
    showAdd: {
      type: Boolean,
      default: false
    },
    editPage: {
      type: Boolean
    },
    viewDatalist: {
      type: Object
    },
    returnCampaignObjective: {
      type: String
    },
    pageId: {
      type: String
    },
    goalsObjectiveData: {
      type: String
    },
    campaignId: {
      type: String
    },
    lang: {
      type: Object
    },
    showTargetCR: {
      type: Boolean
    },
    showOtherTargetCR: {
      type: Boolean
    },
    formActive: {
      type: String
    }
  },
  data() {
    return {
      isEdit: false,
      showSelectPostDialogMyside: false,
      showMaterialSingle: true,
      showMaterial: true,
      showVideoLoading: true,
      currentTab: 0,
      fb1Image: fb1Image,
      fb2Image: fb2Image,
      auto: true,
      type: 1,
      activeType: 1,
      activeItem: 0,
      focusType: 0,
      selectedForm: 'image',
      prview_now: null,
      prview_single: null,
      // videoIsRequired: true,
      nowItemIndex: 0,
      materials: [
        {
          imgSrc: null,
          title: "",
          description: "",
          website: "",
          isEdit: false
        },
        {
          imgSrc: "http://placehold.it/100x100",
          title: "",
          description: "",
          website: "",
          isEdit: false
        }
      ],
      showModal: false,
      call: null,
      moreInput: true,
      items: [
        {
          title: "xxxx",
          isEdit: false,
          type: 1,
          videoIsRequired: true,
          materials: [
            {
              id: null,
              imgSrc: null,
              object_spec: {
                name: null,
                width: null,
                height: null
              },
              title: null,
              description: null,
              website: null,
              isEdit: false,
              index: 0
            },
            {
              id: null,
              imgSrc: null,
              object_spec: {
                name: null,
                width: null,
                height: null
              },
              title: null,
              description: null,
              website: null,
              isEdit: false,
              index: 1
            }
          ],
          materialSingle: [
            {
              id: null,
              imgSrc: null,
              object_spec: {
                name: null,
                width: null,
                height: null
              },
              fileName: null,
              title: null,
              description: null,
              website: null,
              size: null,
              index: 0
            }
          ],
          callActive: 'SIGN_UP'
        },
        // {
        //   title: "廣告2",
        //   isEdit: false,
        //   type: 2,
        //   materials: [
        //     {
        //       imgSrc: null,
        //       title: "title1",
        //       description: "des1",
        //       website: "autoturn",
        //       isEdit: false
        //     },
        //     {
        //       imgSrc: "http://placehold.it/100x100",
        //       title: "title2",
        //       description: "des2",
        //       website: "fb",
        //       isEdit: false
        //     }
        //   ],
        //   callActive: 'SIGN_UP'
        // },
        // {
        //   title: "廣告1231232",
        //   isEdit: false,
        //   type: 1,
        //   materialSingle: [
        //     {
        //       src: "http://placehold.it/100x100",
        //       title: "test3333",
        //       size: "300*400"
        //     }
        //   ],
        //   callActive: 'BOOK_TRAVEL'
        // }
      ],
      showVideoWindows: false,
      image: {
        active: null,
        imageList: [
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg"
        ],
        imageListSpec: [],
        imageListName: [],
        imageListTitle: []
      },
      video: {
        active: null,
        videoList: [
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg"
        ],
        videoListSpec: [],
        videoListName: [],
        videoListTitle: []
      },
      imageAfter: '',
      videoAfter: '',
      materialSingle: [
        {
          src: "http://placehold.it/100x100",
          title: "test",
          size: "800*800"
        }
      ],
      callActiveFocusNow: null,
      callActiveFocus: {
        'CONVERSIONS': 'LEARN_MORE',
        'LINK_CLICKS': 'LEARN_MORE',
        'POST_ENGAGEMENT': 'NO_BUTTON',
        'VIDEO_VIEWS': 'LEARN_MORE',
      },
      callActiveList: {},
      ai_x: 0,
      ai_y: 0,
      ai_h: 200,
      ai_w: 320,
      active: false,
      src: "https://www.youtube.com/watch?v=3wGiBNSfa8E",
      vars: {
        rel: 0,
        start: 0,
        end: 0,
      },
      view_youtube: false,
      view_ai: false,
      aiWord: null,
      aiType: null,
      aiMainIndex: null,
      aiItemIndex: null,
      formTarget: null,
      aiContentProcessing: false,
      itemCheckedIndex: null,
      aiContentReturn: [],
      processText: '產生',
      showAiPictureModal: false,
      fileUpload: null,
      fileName: '',
      imageFile: null,
      showUploadWindows: false,
      useUpload: false,
      selectedFiles: [], // 存储选中的文件
      uploadResults: [], // 存储每张图片的上传结果
      isUploading: false, // 上传状态
      showUploadVideoWindows: false,
      useVideoUpload: false,
      selectedVideoFiles: [], // 存储选中的文件
      uploadVideoResults: [], // 存储每张图片的上传结果
      videoIsUploading: false, // 上传状态
    };
  },
  watch: {
    lang(value){
      console.log('watch lang value');
      console.log(value);
      // this.callActiveList = {
      //     'CONVERSIONS': [
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['no_button'], code: 'NO_BUTTON' },
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['book_travel'], code: 'BOOK_TRAVEL'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['contact_us'], code: 'CONTACT_US'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['download'], code: 'DOWNLOAD'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['get_offer'], code: 'GET_OFFER'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['get_quote'], code: 'GET_QUOTE'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['get_showtimes'], code: 'GET_SHOWTIMES'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['listen_now'], code: 'LISTEN_NOW'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['order_now'], code: 'ORDER_NOW'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['play_game'], code: 'PLAY_GAME'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['request_time'], code: 'REQUEST_TIME'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['see_menu'], code: 'SEE_MENU'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['shop_now'], code: 'SHOP_NOW'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['sign_up'], code: 'SIGN_UP'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['subscribe'], code: 'SUBSCRIBE'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['watch_more'], code: 'WATCH_MORE'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['learn_more'], code: 'LEARN_MORE'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['apply_now'], code: 'APPLY_NOW'},
      //     ],
      //     'LINK_CLICKS': [
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['no_button'], code: 'NO_BUTTON' },
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['book_travel'], code: 'BOOK_TRAVEL'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['contact_us'], code: 'CONTACT_US'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['download'], code: 'DOWNLOAD'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['get_offer'], code: 'GET_OFFER'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['get_quote'], code: 'GET_QUOTE'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['pay_to_access'], code: 'PAY_TO_ACCESS'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['get_showtimes'], code: 'GET_SHOWTIMES'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['listen_now'], code: 'LISTEN_NOW'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['order_now'], code: 'ORDER_NOW'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['request_time'], code: 'REQUEST_TIME'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['see_menu'], code: 'SEE_MENU'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['shop_now'], code: 'SHOP_NOW'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['sign_up'], code: 'SIGN_UP'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['subscribe'], code: 'SUBSCRIBE'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['watch_more'], code: 'WATCH_MORE'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['learn_more'], code: 'LEARN_MORE'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['apply_now'], code: 'APPLY_NOW'},
      //     ],
      //     'POST_ENGAGEMENT': [
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['post_engagement']['no_button'], code: 'NO_BUTTON' },
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['post_engagement']['get_quote'], code: 'GET_QUOTE'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['post_engagement']['learn_more'], code: 'LEARN_MORE'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['post_engagement']['message_page'], code: 'MESSAGE_PAGE'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['post_engagement']['shop_now'], code: 'SHOP_NOW'},
      //     ],
      //     'VIDEO_VIEWS': [
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['video_views']['book_travel'], code: 'BOOK_TRAVEL'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['video_views']['download'], code: 'DOWNLOAD'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['video_views']['get_quote'], code: 'GET_QUOTE'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['video_views']['get_showtimes'], code: 'GET_SHOWTIMES'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['video_views']['listen_now'], code: 'LISTEN_NOW'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['video_views']['shop_now'], code: 'SHOP_NOW'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['video_views']['sign_up'], code: 'SIGN_UP'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['video_views']['subscribe'], code: 'SUBSCRIBE'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['video_views']['watch_more'], code: 'WATCH_MORE'},
      //       { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['video_views']['learn_more'], code: 'LEARN_MORE'},
      //     ],
      //   };
    },
    viewDatalist (value){
      // console.log('viewDatalist');
      // console.log(this.viewDatalist);
      // console.log(value);

      // console.log(this.items);
      this.items = value.creative_array;
      // console.log(this.items);
    },
    showAdd(value){
      // console.log('showAdd');
      // console.log(value);
      if(value == true){
        this.callActiveList = {
          'CONVERSIONS': [
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['no_button'], code: 'NO_BUTTON' },
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['book_travel'], code: 'BOOK_TRAVEL'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['contact_us'], code: 'CONTACT_US'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['download'], code: 'DOWNLOAD'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['get_offer'], code: 'GET_OFFER'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['get_quote'], code: 'GET_QUOTE'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['get_showtimes'], code: 'GET_SHOWTIMES'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['listen_now'], code: 'LISTEN_NOW'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['order_now'], code: 'ORDER_NOW'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['play_game'], code: 'PLAY_GAME'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['request_time'], code: 'REQUEST_TIME'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['see_menu'], code: 'SEE_MENU'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['shop_now'], code: 'SHOP_NOW'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['sign_up'], code: 'SIGN_UP'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['subscribe'], code: 'SUBSCRIBE'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['watch_more'], code: 'WATCH_MORE'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['learn_more'], code: 'LEARN_MORE'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['conversions']['apply_now'], code: 'APPLY_NOW'},
          ],
          'LINK_CLICKS': [
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['no_button'], code: 'NO_BUTTON' },
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['book_travel'], code: 'BOOK_TRAVEL'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['contact_us'], code: 'CONTACT_US'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['download'], code: 'DOWNLOAD'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['get_offer'], code: 'GET_OFFER'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['get_quote'], code: 'GET_QUOTE'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['pay_to_access'], code: 'PAY_TO_ACCESS'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['get_showtimes'], code: 'GET_SHOWTIMES'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['listen_now'], code: 'LISTEN_NOW'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['order_now'], code: 'ORDER_NOW'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['request_time'], code: 'REQUEST_TIME'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['see_menu'], code: 'SEE_MENU'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['shop_now'], code: 'SHOP_NOW'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['sign_up'], code: 'SIGN_UP'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['subscribe'], code: 'SUBSCRIBE'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['watch_more'], code: 'WATCH_MORE'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['learn_more'], code: 'LEARN_MORE'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['link_clicks']['apply_now'], code: 'APPLY_NOW'},
          ],
          'POST_ENGAGEMENT': [
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['post_engagement']['no_button'], code: 'NO_BUTTON' },
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['post_engagement']['get_quote'], code: 'GET_QUOTE'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['post_engagement']['learn_more'], code: 'LEARN_MORE'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['post_engagement']['message_page'], code: 'MESSAGE_PAGE'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['post_engagement']['shop_now'], code: 'SHOP_NOW'},
          ],
          'VIDEO_VIEWS': [
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['video_views']['book_travel'], code: 'BOOK_TRAVEL'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['video_views']['download'], code: 'DOWNLOAD'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['video_views']['get_quote'], code: 'GET_QUOTE'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['video_views']['get_showtimes'], code: 'GET_SHOWTIMES'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['video_views']['listen_now'], code: 'LISTEN_NOW'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['video_views']['shop_now'], code: 'SHOP_NOW'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['video_views']['sign_up'], code: 'SIGN_UP'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['video_views']['subscribe'], code: 'SUBSCRIBE'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['video_views']['watch_more'], code: 'WATCH_MORE'},
            { name: this.lang['components']['Event']['AddMaterial']['call_active_list']['video_views']['learn_more'], code: 'LEARN_MORE'},
          ],
        };

        this.prview_single = null;

        if(this.goalsObjectiveData == 'VIDEO_VIEWS'){
          this.videoIsRequired = false;
        } else {
          this.videoIsRequired = true;
        }

        this.items = [
          {
            title: "xxxx",
            isEdit: false,
            type: 1,
            videoIsRequired: true,
            materials: [
              {
                id: null,
                imgSrc: null,
                object_spec: {
                  name: null,
                  width: null,
                  height: null
                },
                title: null,
                description: null,
                website: null,
                isEdit: false,
                index: 0
              },
              {
                id: null,
                imgSrc: null,
                object_spec: {
                  name: null,
                  width: null,
                  height: null
                },
                title: null,
                description: null,
                website: null,
                isEdit: false,
                index: 1
              }
            ],
            materialSingle: [
              {
                id: null,
                imgSrc: null,
                object_spec: {
                  name: null,
                  width: null,
                  height: null
                },
                fileName: null,
                title: null,
                description: null,
                website: null,
                size: null,
                index: 0
              }
            ],
            callActive: this.callActiveFocus[this.goalsObjectiveData]
          },
        ]
      }
    },
    videoIsRequired(value){
      // console.log('videoIsRequired');
      // console.log(value);
      // console.log(this.items);
      this.items[this.nowItemIndex].materialSingle[0].title = '';
      this.items[this.nowItemIndex].materialSingle[0].description = '';
      this.items[this.nowItemIndex].link = '';
      this.items[this.nowItemIndex].caption = '';
    },
    itemCheckedIndex(value){
      console.log('itemCheckedIndex');
      console.log(value);
    },
    showUploadWindows(value){
      console.log('showUploadWindows');
      console.log(value);

      if(value == false && this.useUpload == true){
        console.log('有上傳圖片');
        this.materialUpdate();

        this.useUpload = false;
      }

      if(value == true){
        console.log('準備上傳圖片');
        this.selectedFiles = [];
        this.uploadResults = [];
        this.isUploading = false;
      }
    },
    showUploadVideoWindows(value){
      console.log('showUploadVideoWindows');
      console.log(value);

      if(value == false && this.useVideoUpload == true){
        console.log('有上傳影片');
        this.materialUpdate();

        this.useVideoUpload = false;
      }

      if(value == true){
        console.log('準備上傳影片');
        this.selectedVideoFiles = [];
        this.uploadVideoResults = [];
        this.videoIsUploading = false;
      }
    },
  },
  methods: {
    unlock(){
      this.isEdit = false
    },
    lock(){
      this.isEdit = true
    },
    changeType(index, value){
      if(this.editPageType == false){
        this.items[index].type = value
        this.focusType = index

        // console.log('changeType');
        // console.log('items['+index+'].type');
        // console.log(this.items[index].type);
        // console.log('focusType');
        // console.log(this.focusType);
      }
    },
    changeSelectedForm(index, value){
      if(this.editPageType == false){
        if(value == 'image'){
          this.image.active = index
          this.selectedForm = 'image'
        } else {
          this.video.active = index
          this.selectedForm = 'video'
        }
      }
    },
    addItem() {
      // this.items.push({ title: "xxxxxx" });
      if(this.editPageType == false){
        this.items.push(
          {
            title: "廣告xxxx",
            isEdit: false,
            type: 1,
            videoIsRequired: true,
            materials: [
              {
                id: null,
                imgSrc: null,
                object_spec: {
                  name: null,
                  width: null,
                  height: null
                },
                title: null,
                description: null,
                website: null,
                isEdit: false,
                index: 0
              },
              {
                id: null,
                imgSrc: null,
                object_spec: {
                  name: null,
                  width: null,
                  height: null
                },
                title: null,
                description: null,
                website: null,
                isEdit: false,
                index: 1
              }
            ],
            materialSingle: [
              {
                id: null,
                imgSrc: null,
                object_spec: {
                  name: null,
                  width: null,
                  height: null
                },
                fileName: null,
                title: null,
                description: null,
                website: null,
                size: null,
                index: 0
              }
            ],
            callActive: this.callActiveFocus[this.goalsObjectiveData]
          }
        );

        this.$emit('childAdIsChangeData', true);
        this.$emit('childContent', this.items);
      }
    },
    setMaterial(type) {
      let activeType = this.activeType
      let activeItem = this.activeItem

      // console.log('setMaterial type:'+type);
      // console.log('setMaterial activeType:'+activeType);
      // console.log('setMaterial activeItem:'+activeItem);

      if(this.editPageType == false){
        if(activeType == 1){
          if(this.selectedForm == 'image'){
            if (
              this.image.active != null &&
              this.image.imageList.length > this.image.active
            ) {
              this.items.materialSingle == []

              // console.log('1 image this.image.active');
              // console.log(this.image.active);
              // console.log('this.image');
              // console.log(this.image);

              this.items[type].materialSingle = [{
                id: this.image.imageListSpec[this.image.active].id,
                imgSrc: this.image.imageList[this.image.active],
                object_spec: this.image.imageListSpec[this.image.active],
                fileName: this.image.imageListSpec[this.image.active].name,
                title: this.items[type].materialSingle[0].title,
                size: this.image.imageListSpec[this.image.active].width+' * '+this.image.imageListSpec[this.image.active].height,
                index: 0
              }];

              this.image.active = null;
              this.showVideoWindows = false;
            }
          } else {
            if (
              this.video.active != null &&
              this.video.videoList.length > this.video.active
            ) {
              this.items.materialSingle == []

              // console.log('1 video this.video.active');
              // console.log(this.video.active);
              // console.log('this.video');
              // console.log(this.video);

              this.items[type].materialSingle = [{
                id: this.video.videoListSpec[this.video.active].id,
                imgSrc: this.video.videoList[this.video.active],
                object_spec: this.video.videoListSpec[this.video.active],
                fileName: this.video.videoListSpec[this.video.active].title,
                title: this.items[type].materialSingle[0].title,
                size: this.video.videoListSpec[this.video.active].width+' * '+this.video.videoListSpec[this.video.active].height,
                index: 0
              }];

              this.video.active = null;
              this.showVideoWindows = false;
            }
          }
        }

        if(activeType == 2){
          let this_length = this.items[type].materials.length;
          if(this.selectedForm == 'image'){
            if (
              this.image.active != null &&
              this.image.imageList.length > this.image.active
            ) {
              this.items.materials == []

              // console.log('2 image this.image.active');
              // console.log(this.image.active);
              // console.log(this.image.imageList[this.image.active]);
              // console.log(this.items);
              // console.log(this.items[activeType]);
              // console.log('this.image');
              // console.log(this.image);

              // this.items[activeType].materials.push({
              //   imgSrc: this.image.imageList[this.image.active],
              //   title: "",
              //   size: "800*800"
              // });

              if(typeof this.items[type].materials[activeItem].index != 'undefined'){
                this_length = this.items[type].materials[activeItem].index;
              }

              this.items[type].materials[activeItem] = {
                id: this.image.imageListSpec[this.image.active].id,
                imgSrc: this.image.imageList[this.image.active],
                object_spec: this.image.imageListSpec[this.image.active],
                title: this.items[type].materials[activeItem].title,
                size: "800*800",
                isEdit: true,
                index: this_length
              };

              // console.log(this.items[type]);

              this.image.active = null;
              this.showVideoWindows = false;
            }
          } else {
            if (
              this.video.active != null &&
              this.video.videoList.length > this.video.active
            ) {
              this.items.materials == []

              // console.log('2 video this.video.active');
              // console.log(this.video.active);
              // console.log('this.video');
              // console.log(this.video);

              // this.items[activeType].materials.push({
              //   imgSrc: this.video.videoList[this.video.active],
              //   title: "",
              //   size: "800*800"
              // });

              if(typeof this.items[type].materials[activeItem].index != 'undefined'){
                this_length = this.items[type].materials[activeItem].index;
              }

              this.items[type].materials[activeItem] = {
                id: this.video.videoListSpec[this.video.active].id,
                imgSrc: this.video.videoList[this.video.active],
                object_spec: this.video.videoListSpec[this.video.active],
                title: this.items[type].materials[activeItem].title,
                size: "800*800",
                isEdit: true,
                index: this_length
              };

              this.video.active = null;
              this.showVideoWindows = false;
            }
          }
        }

        console.log('this.items');
        console.log(this.items);

        this.$emit('childAdIsChangeData', true);
        this.$emit('childContent', this.items);

        this.adPreview(this.currentTab);
      }

      // console.log('this.items');
      // console.log(this.items);
    },
    getImageVideoList(type, index){
      console.log('getImageVideoList type:'+type);
      console.log('getImageVideoList index:');
      console.log(index);

      // if(this.editPageType == false){

        // if(type == 1){
        //   this.showMaterialSingle = false;
        // } else {
        //   this.showMaterial = false;
        // }

        this.showVideoWindows = true;
        this.showVideoLoading = false;

        this.image.imageList = null;
        this.image.imageListSpec = null;
        this.image.imageListName = null;
        this.image.imageListTitle = null;
        this.video.videoList = null;
        this.video.videoListSpec = null;
        this.video.videoListName = null;
        this.video.videoListTitle = null;

        this.activeType = null;
        this.activeItem = null;

        axios
          .post('https://test.autoturn.net/inside/api/campaign_form_adimages.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              this.imageAfter = response.data.after_image

              this.image.imageList = response.data.return_image
              this.image.imageListSpec = response.data.return_image_spec
              this.image.imageListName = response.data.return_image_name
              this.image.imageListTitle = response.data.return_image_title

              // this.activeType = type
              // this.activeItem = index

              // this.showVideoLoading = true;

              axios
              .post('https://test.autoturn.net/inside/api/campaign_form_advideos.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
              }))
              .then((response) => {
                // if(response.data.status == 'success'){
                  this.videoAfter = response.data.after_video

                  this.video.videoList = response.data.return_video
                  this.video.videoListSpec = response.data.return_video_spec
                  this.video.videoListName = response.data.return_video_name
                  this.video.videoListTitle = response.data.return_video_title

                  this.activeType = type
                  this.activeItem = index

                  // if(type == 1){
                  //   this.showMaterialSingle = true;
                  // } else {
                  //   this.showMaterial = true;
                  // }

                  // this.showVideoWindows = true

                  this.showVideoLoading = true;
                // }
              });
            } else {
              axios
              .post('https://test.autoturn.net/inside/api/campaign_form_advideos.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
              }))
              .then((response) => {
                // if(response.data.status == 'success'){
                  this.videoAfter = response.data.after_video

                  this.video.videoList = response.data.return_video
                  this.video.videoListSpec = response.data.return_video_spec
                  this.video.videoListName = response.data.return_video_name
                  this.video.videoListTitle = response.data.return_video_title

                  this.activeType = type
                  this.activeItem = index

                  // if(type == 1){
                  //   this.showMaterialSingle = true;
                  // } else {
                  //   this.showMaterial = true;
                  // }

                  // this.showVideoWindows = true

                  this.showVideoLoading = true;
                // }
              });
            }
          });
      // }
    },
    moreVideo(){
      console.log('moreVideo');

      // let thisVideoList = ['video111.jpg','video222.jpg'];
      // let thisVideoListSpec = ['111','222'];
      // let thisVideoListName = ['video111','video222'];
      // let thisVideoListTitle = ['video111','video222'];

      this.showVideoLoading = false;

      axios
        .post('https://test.autoturn.net/inside/api/campaign_form_advideos.php', Qs.stringify({
          s_code: this.$route.params.id,
          adaccount_id: this.$route.params.adaccount_id,
          video_material_code: this.videoAfter,
        }))
        .then((response) => {
          // if(response.data.status == 'success'){
            // this.video.videoList = response.data.return_video
            // this.video.videoListSpec = response.data.return_video_spec
            // this.video.videoListName = response.data.return_video_name
            // this.video.videoListTitle = response.data.return_video_title

            // if(type == 1){
            //   this.showMaterialSingle = true;
            // } else {
            //   this.showMaterial = true;
            // }

            // this.showVideoWindows = true

            // this.showVideoLoading = true;
            this.videoAfter = response.data.after_video;

            this.video.videoList = response.data.return_video;
            this.video.videoListSpec = response.data.return_video_spec;
            this.video.videoListName = response.data.return_video_name;
            this.video.videoListTitle = response.data.return_video_title;

            this.showVideoLoading = true;
          // }
        });
    },
    moreImage(){
      console.log('moreImage');

      // let thisImageList = ['image111.jpg','image222.jpg'];
      // let thisImageListSpec = ['111','222'];
      // let thisImageListName = ['image111','image222'];
      // let thisImageListTitle = ['image111','image222'];

      this.showVideoLoading = false;

      axios
        .post('https://test.autoturn.net/inside/api/campaign_form_adimages.php', Qs.stringify({
          s_code: this.$route.params.id,
          adaccount_id: this.$route.params.adaccount_id,
          image_material_code: this.imageAfter,
        }))
        .then((response) => {
          // if(response.data.status == 'success'){
            // this.image.imageList = response.data.return_image
            // this.image.imageListSpec = response.data.return_image_spec
            // this.image.imageListName = response.data.return_image_name
            // this.image.imageListTitle = response.data.return_image_title

            // if(type == 1){
            //   this.showMaterialSingle = true;
            // } else {
            //   this.showMaterial = true;
            // }

            // this.showVideoWindows = true

            // this.showVideoLoading = true;
            this.imageAfter = response.data.after_image;

            this.image.imageList = response.data.return_image;
            this.image.imageListSpec = response.data.return_image_spec;
            this.image.imageListName = response.data.return_image_name;
            this.image.imageListTitle = response.data.return_image_title;

            this.showVideoLoading = true;
          // }
        });
    },
    adContent(index){
      // console.log('adContent');
      // console.log(index);
      // console.log(this.items[index].preview);
      // console.log(this.items[index]);

      // if(this.editPageType == false){
        this.currentTab = index
        this.prview_now = this.items[index].preview

        this.nowItemIndex = index;
        this.$emit('childFormId', this.items[index].form_sr_i);
        this.$emit('childMessageId', this.items[index].message_sr_i);
      // }
    },
    addMaterials(index){
      // console.log('addMaterials:'+index);
      let this_length = this.items[index].materials.length;

      if(this.editPageType == false){
        if(this_length < 10){
          this.items[index].materials.push({
            id: null,
            imgSrc: null,
            object_spec: {
              name: null,
              width: null,
              height: null
            },
            title: null,
            description: null,
            website: null,
            isEdit: false,
            index: this_length
          });

          this.$emit('childAdIsChangeData', true);
          this.$emit('childContent', this.items);
        } else {
          Swal.fire(
                    this.lang['components']['Event']['AddMaterial']['methods']['addMaterials']['not_length_swal_title'],
                    this.lang['components']['Event']['AddMaterial']['methods']['addMaterials']['not_length_swal_text'],
                    'warning'
                  );
        }
      }

      this.adPreview(this.currentTab);

      // console.log(this.items[index].materials);
    },
    removeAd(index){
      // console.log('removeAd index:'+index);

      if(this.editPageType == false){
        this.items.splice(index, 1);

        this.$emit('childAdIsChangeData', true);
        this.$emit('childContent', this.items);
      }
    },
    isChangeData(){
      // console.log('isChangeData');
      this.$emit('childAdIsChangeData', true);
      this.$emit('childContent', this.items);

      this.adPreview(this.currentTab);
    },
    removeItem(type, index){
      // console.log('removeItem type:'+type);
      // console.log('removeItem index:'+index);

      if(this.editPageType == false){
        // console.log('b this.items:');
        // console.log(this.items);
        // console.log('this.items['+type+'].materials:');
        // console.log(this.items[type].materials);
        this.items[type].materials.splice(index, 1);

        for(var i = 0; i < this.items[type].materials.length; i++){
          this.items[type].materials[i].index = i;
        }

        this.$emit('childAdIsChangeData', true);
        this.$emit('childContent', this.items);

        // console.log('a this.items:');
        // console.log(this.items);
      }
    },
    IsURL(str_url){
      console.log('str_url');
      console.log(str_url);
      // var strRegex = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
      // // var strRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/;
      // // var strRegex = /^(http|https):\/\/[\w\-_\u4E00-\u9FA5:/]+(\.[\w\-_\u4E00-\u9FA5]+)+([\u4E00-\u9FA5\w\-.,@?^=%&:/~+#]*[\u4E00-\u9FA5\w\-@?^=%&/~+#])?$/;
      // var re = new RegExp(strRegex);
      // //re.test()
      // if (re.test(str_url)){
      //   console.log('#1');
        return true;
      // } else {
      //   console.log('#2');
      //   return false;
      // }
    },
    save(){
      // console.log(this.items);
      // console.log('this.goalsObjectiveData:');
      // console.log(this.goalsObjectiveData);
      // console.log('this.campaignId');
      // console.log(this.campaignId);

      console.log('this.items');
      console.log(this.items);

      let needLink = 0;
      let formatLink = 0;
      let objectSpec = 0;
      let message = 0;
      let title = 0;
      let description = 0;
      let caption = 0;
      let material_message = 0;
      for(let i = 0; i < this.items.length; i++){
        if(this.items[i].type == 1){
          if(this.items[i].materialSingle[0].object_spec.id == null || this.items[i].materialSingle[0].object_spec.id == '' || typeof this.items[i].materialSingle[0].object_spec.id == 'undefined'){
            objectSpec = 1;
          }

          if((this.items[i].materialSingle[0].title == null || this.items[i].materialSingle[0].title == '' || typeof this.items[i].materialSingle[0].title == 'undefined') && this.goalsObjectiveData != 'VIDEO_VIEWS'){
            title = 1;
          }
        }

        if(this.items[i].type == 2){
          for(let j = 0; j < this.items[i].materials.length; j++){
            if(this.items[i].materials[j].object_spec.id == null || this.items[i].materials[j].object_spec.id == '' || typeof this.items[i].materials[j].object_spec.id == 'undefined'){
              objectSpec = 1;
            }

            if(this.items[i].materials[j].title == null || this.items[i].materials[j].title == '' || typeof this.items[i].materials[j].title == 'undefined'){
              title = 1;
            }
          }
        }

        if(this.items[i].message == null || this.items[i].message == '' || typeof this.items[i].message == 'undefined'){
          message = 1;
        }

        if(this.goalsObjectiveData == 'CONVERSIONS' || this.goalsObjectiveData == 'LINK_CLICKS'){
          if(this.items[i].type == 1){
            if(this.items[i].link == null || this.items[i].link == '' || typeof this.items[i].link == 'undefined'){
              if(this.items[i].callActive != 'NO_BUTTON'){
                needLink = 1;
              }
            }

            let items1_link = this.items[i].link
            if(this.IsURL(items1_link) == false){
              formatLink = 1;
            }
          }

          if(this.items[i].type == 2){
            for(let j = 0; j < this.items[i].materials.length; j++){
              if(this.items[i].materials[j].website == null || this.items[i].materials[j].website == '' || typeof this.items[i].materials[j].website == 'undefined'){
                if(this.items[i].callActive != 'NO_BUTTON'){
                  needLink = 1;
                }
              }

              let items2_link = this.items[i].materials[j].website
              if(this.IsURL(items2_link) == false){
                formatLink = 1;
              }
            }
          }
        }

        if(this.goalsObjectiveData == 'POST_ENGAGEMENT'){
          if(this.items[i].type == 1){
            if(this.items[i].link == null || this.items[i].link == '' || typeof this.items[i].link == 'undefined'){
              if(this.items[i].callActive != 'NO_BUTTON' && this.items[i].callActive != 'MESSAGE_PAGE'){
                needLink = 1;
              }
            }

            let items1_link = this.items[i].link
            if(this.IsURL(items1_link) == false){
              formatLink = 1;
            }
          }
        }

        if(this.goalsObjectiveData == 'VIDEO_VIEWS'){
          if(this.items[i].type == 1){
            if((this.items[i].materialSingle[0].title == null || this.items[i].materialSingle[0].title == '' || typeof this.items[i].materialSingle[0].title == 'undefined') && this.items[i].videoIsRequired == true){
              title = 1;
            }

            if((this.items[i].materialSingle[0].description == null || this.items[i].materialSingle[0].description == '' || typeof this.items[i].materialSingle[0].description == 'undefined') && this.items[i].videoIsRequired == true){
              description = 1;
            }

            if(this.items[i].link == null || this.items[i].link == '' || typeof this.items[i].link == 'undefined'){
              // if(this.items[i].caption != null && this.items[i].caption != '' && typeof this.items[i].caption != 'undefined'){
              //   needLink = 1;
              // }

              // if(this.items[i].materialSingle[0].description != null && this.items[i].materialSingle[0].description != '' && typeof this.items[i].materialSingle[0].description != 'undefined'){
              //   needLink = 1;
              // }
              if(this.items[i].videoIsRequired == true){
                needLink = 1;
              }
            }

            let items1_link = this.items[i].link
            if(this.IsURL(items1_link) == false){
              formatLink = 1;
            }

            if((this.items[i].caption == null || this.items[i].caption == '' || typeof this.items[i].caption == 'undefined') && this.items[i].videoIsRequired == true){
              caption = 1;
            }
          }
        }

        if(this.items[i].title == null || this.items[i].title == '' || typeof this.items[i].title == 'undefined'){
          material_message = 1;
        }
      }

      if(objectSpec == 1){
        Swal.fire(
                    this.lang['components']['Event']['AddMaterial']['methods']['save']['swal_title'],
                    this.lang['components']['Event']['AddMaterial']['methods']['save']['not_object_spec_swal_text'],
                    "error"
                  )
      } else if(message == 1){
        Swal.fire(
                    this.lang['components']['Event']['AddMaterial']['methods']['save']['swal_title'],
                    this.lang['components']['Event']['AddMaterial']['methods']['save']['not_message_swal_text'],
                    "error"
                  )
      } else if(title == 1){
        Swal.fire(
                    this.lang['components']['Event']['AddMaterial']['methods']['save']['swal_title'],
                    this.lang['components']['Event']['AddMaterial']['methods']['save']['not_title_swal_text'],
                    "error"
                  )
      } else if(description == 1 && this.goalsObjectiveData == 'VIDEO_VIEWS'){
        Swal.fire(
                    this.lang['components']['Event']['AddMaterial']['methods']['save']['swal_title'],
                    this.lang['components']['Event']['AddMaterial']['methods']['save']['not_description_swal_text'],
                    "error"
                  )
      } else if(caption == 1 && this.goalsObjectiveData == 'VIDEO_VIEWS'){
        Swal.fire(
                    this.lang['components']['Event']['AddMaterial']['methods']['save']['swal_title'],
                    this.lang['components']['Event']['AddMaterial']['methods']['save']['not_caption_swal_text'],
                    "error"
                  )
      } else if(needLink == 1){
        Swal.fire(
                    this.lang['components']['Event']['AddMaterial']['methods']['save']['swal_title'],
                    this.lang['components']['Event']['AddMaterial']['methods']['save']['not_link_swal_text'],
                    "error"
                  )
      } else if(formatLink == 1){
        Swal.fire(
                    this.lang['components']['Event']['AddMaterial']['methods']['save']['swal_title'],
                    this.lang['components']['Event']['AddMaterial']['methods']['save']['link_format_error_swal_text'],
                    "error"
                  )
      } else if(material_message == 1){
        Swal.fire(
                    this.lang['components']['Event']['AddMaterial']['methods']['save']['swal_title'],
                    this.lang['components']['Event']['AddMaterial']['methods']['save']['material_message_error_swal_text'],
                    "error"
                  )
      } else {
        // console.log('網址都有填');
        if(this.items.length > 0 && this.items != null || typeof this.items != 'undefined'){
          Swal.fire({
            title: this.lang['components']['Event']['AddMaterial']['methods']['save']['item']['swal_title'],
            html: this.lang['components']['Event']['AddMaterial']['methods']['save']['item']['swal_html_c'],
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.lang['components']['Event']['AddMaterial']['methods']['save']['item']['yes_button'],
            cancelButtonText: this.lang['components']['Event']['AddMaterial']['methods']['save']['item']['no_button'],
          }).then((result) => {
            if (result.isConfirmed) {
              // console.log(this.$route.params.id);
              this.showSelectPostDialogMyside = true;

              let member_hash = this.$route.params.id;
              let adaccount_id = this.$route.params.adaccount_id;

              console.log('creative_add this.showTargetCR');
              console.log(this.showTargetCR);
              console.log('creative_add this.showOtherTargetCR');
              console.log(this.showOtherTargetCR);

              let creativeAddUrl = 'https://test.autoturn.net/inside/api/data/creative_add.php';
              if(this.showTargetCR == true || this.showOtherTargetCR == true){
                creativeAddUrl = 'https://test.autoturn.net/inside/api/data/stage_creative_add.php';
              }

              console.log(creativeAddUrl);

              axios
                .post(creativeAddUrl, Qs.stringify({
                  s_code: member_hash,
                  adaccount_id: adaccount_id,
                  page_id: this.pageId,
                  objective: this.goalsObjectiveData,
                  campaign_id:this.campaignId,
                  items: this.items,
                }))
                .then((caResponse) => {
                  // console.log('caResponse:');
                  // console.log(caResponse);

                  this.showSelectPostDialogMyside = false;
                  if(caResponse.data.status == 'success'){

                    this.$emit('update:creativesDatalist', caResponse.data.return_data);
                    this.$emit('update:prviewCreativesDatalist', caResponse.data.return_prview);
                    this.$emit('childAddMaterial', true);

                    if(this.showTargetCR == true || this.showOtherTargetCR == true){
                      this.$emit('childCreativesId', caResponse.data.return_creative);
                    }

                    Swal.fire({
                      icon: 'success',
                      title: this.lang['components']['Event']['AddMaterial']['methods']['save']['item']['swal_title'],
                      text: this.lang['components']['Event']['AddMaterial']['methods']['save']['item']['status_success_swal_text'],
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.lang['components']['Event']['AddMaterial']['methods']['save']['item']['confirm_button'],
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        this.showAddModal = false
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        this.showAddModal = false
                      }
                    })
                  } else {
                    Swal.fire({
                      icon: 'error',
                      title: this.lang['components']['Event']['AddMaterial']['methods']['save']['item']['swal_title'],
                      text: caResponse.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.lang['components']['Event']['AddMaterial']['methods']['save']['item']['confirm_button'],
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        this.showAddModal = false
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        this.showAddModal = false
                      }
                    })
                  }
                });
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: this.lang['components']['Event']['AddMaterial']['methods']['save']['not_item']['swal_title'],
            text: this.lang['components']['Event']['AddMaterial']['methods']['save']['not_item']['swal_text'],
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: this.lang['components']['Event']['AddMaterial']['methods']['save']['not_item']['confirm_button'],
            // denyButtonText: `Don't save`,
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              // Swal.fire('Saved!', '', 'success')
              // this.showAddModal = false
            } else if (result.isDenied) {
              // Swal.fire('Changes are not saved', '', 'info')
              // this.showAddModal = false
            }
          })
        }
      }
    },
    adPreview(index){
      // console.log(this.items[index]);

      axios
          .post('https://test.autoturn.net/inside/api/campaign_form_ad_preview.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            page_id: this.pageId,
            items: this.items[index]
          }))
          .then((response) => {
            // console.log(response.data);
            if(response.data.status == 'success'){

              this.prview_now = null;

              this.prview_single = response.data.return_data

              // console.log('this.prview_single');
              // console.log(this.prview_single);
              // this.image.imageList = response.data.return_image
              // this.image.imageListSpec = response.data.return_image_spec
              // this.video.videoList = response.data.return_video
              // this.video.videoListSpec = response.data.return_video_spec

              // this.activeType = type
              // this.activeItem = index

              // if(type == 1){
              //   this.showMaterialSingle = true;
              // } else {
              //   this.showMaterial = true;
              // }

              // this.showVideoWindows = true
            }
          });
    },
    materialUpdate(){
      console.log('materialUpdate');
      this.showVideoLoading = false;

      this.image.imageList = null;
      this.image.imageListSpec = null;
      this.image.imageListName = null;
      this.image.imageListTitle = null;
      this.video.videoList = null;
      this.video.videoListSpec = null;
      this.video.videoListName = null;
      this.video.videoListTitle = null;

      axios
        .post('https://test.autoturn.net/inside/api/campaign_form_adimages.php', Qs.stringify({
          s_code: this.$route.params.id,
          adaccount_id: this.$route.params.adaccount_id,
          type: 'update'
        }))
        .then((response) => {
          if(response.data.status == 'success'){
            this.imageAfter = response.data.after_image

            this.image.imageList = response.data.return_image
            this.image.imageListSpec = response.data.return_image_spec
            this.image.imageListName = response.data.return_image_name
            this.image.imageListTitle = response.data.return_image_title

            // if(type == 1){
            //   this.showMaterialSingle = true;
            // } else {
            //   this.showMaterial = true;
            // }

            // this.showVideoWindows = true

            // this.showVideoLoading = true;

            axios
              .post('https://test.autoturn.net/inside/api/campaign_form_advideos.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
                type: 'update'
              }))
              .then((response) => {
                // if(response.data.status == 'success'){
                  this.videoAfter = response.data.after_video

                  this.video.videoList = response.data.return_video
                  this.video.videoListSpec = response.data.return_video_spec
                  this.video.videoListName = response.data.return_video_name
                  this.video.videoListTitle = response.data.return_video_title

                  // if(type == 1){
                  //   this.showMaterialSingle = true;
                  // } else {
                  //   this.showMaterial = true;
                  // }

                  // this.showVideoWindows = true

                  this.showVideoLoading = true;
                // }
              });
          } else {
            axios
              .post('https://test.autoturn.net/inside/api/campaign_form_advideos.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
                type: 'update'
              }))
              .then((response) => {
                // if(response.data.status == 'success'){
                  this.videoAfter = response.data.after_video

                  this.video.videoList = response.data.return_video
                  this.video.videoListSpec = response.data.return_video_spec
                  this.video.videoListName = response.data.return_video_name
                  this.video.videoListTitle = response.data.return_video_title

                  // if(type == 1){
                  //   this.showMaterialSingle = true;
                  // } else {
                  //   this.showMaterial = true;
                  // }

                  // this.showVideoWindows = true

                  this.showVideoLoading = true;
                // }
              });
          }
        });
    },
    useAi(event, type, main_index, item_index){
      console.log('useAi');
      console.log(event);
      console.log(type);
      console.log(main_index);
      console.log(item_index);

      this.aiWord = null;
      this.aiType = type;
      this.aiMainIndex = main_index;
      this.aiItemIndex = item_index;
      this.aiContentProcessing = false;

      const element = event.currentTarget;

      // if (element) {
        const rect = element.getBoundingClientRect();
        console.log('元素位置信息：', rect);
        console.log('元素顶部位置：', rect.top);
        console.log('元素左侧位置：', rect.left);
        // 可以根据需求进一步处理位置信息
        this.ai_x = parseInt(rect.left) - parseInt(150);
        this.ai_y = parseInt(rect.top) - parseInt(40);
      // } else {
      //   console.error('未找到具有指定类名的元素');
      // }

      // let aiWindowWidth = window.innerWidth;
      // let aiWindowHeight = window.innerHeight;

      // console.log('aiWindowWidth');
      // console.log(aiWindowWidth);
      // console.log('aiWindowHeight');
      // console.log(aiWindowHeight);

      // this.ai_x = aiWindowWidth - parseInt(550);
      // this.ai_y = aiWindowHeight - parseInt(400);
      let labelMainIndex = main_index + parseInt(1);
      let labelItemIndex = item_index + parseInt(1);

      switch(type){
        case 'single_message':
          this.formTarget = '針對第 '+labelMainIndex+' 則廣告組的『主要文字』';
          break;
        case 'single_title':
          this.formTarget = '針對第 '+labelMainIndex+' 則廣告組的『標題』';
          break;
        case 'single_description':
          this.formTarget = '針對第 '+labelMainIndex+' 則廣告組的『說明』';
          break;
        case 'carousel_title':
          this.formTarget = '針對第 '+labelMainIndex+' 則廣告組，第 '+labelItemIndex+' 張輪播卡片的『標題』';
          break;
        case 'carousel_description':
          this.formTarget = '針對第 '+labelMainIndex+' 則廣告組，第 '+labelItemIndex+' 張輪播卡片的『說明』';
          break;
      }

      console.log('ai_x');
      console.log(this.ai_x);
      console.log('ai_y');
      console.log(this.ai_y);

      this.itemCheckedIndex = null;
      this.aiContentReturn = [];
      this.view_ai = true;
    },
    generateCopy(){
      console.log('generateCopy');
      console.log(this.aiWord);

      let aiContent = this.aiWord;

      if(this.aiContentProcessing == false){
        if(aiContent != null && aiContent != '' && typeof aiContent != 'undefined'){
          this.processText = '生成中...';
          this.aiContentProcessing = true;
          let _tmpAiContent = aiContent.trim();

          axios
            .post('https://test.autoturn.net/inside/api/ai/ai_material_copywriting_dev.php', Qs.stringify({
              s_code: this.$route.params.id,
              type: this.aiType,
              content: _tmpAiContent
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                // switch(this.aiType){
                //   case 'single_message':
                //     this.viewAdMaterialDatalistData.creative_array[this.aiMainIndex].message = response.data.return_data;
                //     break;
                //   case 'single_title':
                //     this.viewAdMaterialDatalistData.creative_array[this.aiMainIndex].materialSingle[0].title = response.data.return_data;
                //     break;
                //   case 'single_description':
                //     this.viewAdMaterialDatalistData.creative_array[this.aiMainIndex].materialSingle[0].description = response.data.return_data;
                //     break;
                //   case 'carousel_title':
                //     this.viewAdMaterialDatalistData.creative_array[this.aiMainIndex].materials[this.aiItemIndex].title = response.data.return_data;
                //     break;
                //   case 'carousel_description':
                //     this.viewAdMaterialDatalistData.creative_array[this.aiMainIndex].materials[this.aiItemIndex].description = response.data.return_data;
                //     break;
                // }

                this.aiContentReturn = response.data.return_data;
              }

              this.processText = '產生';
              this.aiContentProcessing = false;

              // console.log('this.viewAdMaterialDatalistData.creative_array');
              // console.log(this.viewAdMaterialDatalistData.creative_array);

              // this.view_ai = false;
            });
        } else {
          Swal.fire(
            '生成文案',
            '請輸入要產生的文案大綱。',
            "warning"
          );
        }
      } else {
        Swal.fire(
          '生成文案',
          '文案生成中，請稍等。',
          "warning"
        );
      }
    },
    setAiContent(){
      console.log('setAiContent');
      console.log(this.aiWord);
      console.log('this.aiContentReturn');
      console.log(this.aiContentReturn);
      console.log('this.itemCheckedIndex');
      console.log(this.itemCheckedIndex);

      // let aiContent = this.aiWord;

      let aiContentReturnLength = this.aiContentReturn.length;

      if(aiContentReturnLength > 0){
        if(this.aiContentReturn[this.itemCheckedIndex].content != null && this.aiContentReturn[this.itemCheckedIndex].content != '' && typeof this.aiContentReturn[this.itemCheckedIndex].content != 'undefined'){
          switch(this.aiType){
            case 'single_message':
              this.items[this.aiMainIndex].message = this.aiContentReturn[this.itemCheckedIndex].content;
              break;
            case 'single_title':
              this.items[this.aiMainIndex].materialSingle[0].title = this.aiContentReturn[this.itemCheckedIndex].content;
              break;
            case 'single_description':
              this.items[this.aiMainIndex].materialSingle[0].description = this.aiContentReturn[this.itemCheckedIndex].content;
              break;
            case 'carousel_title':
              this.items[this.aiMainIndex].materials[this.aiItemIndex].title = this.aiContentReturn[this.itemCheckedIndex].content;
              break;
            case 'carousel_description':
              this.items[this.aiMainIndex].materials[this.aiItemIndex].description = this.aiContentReturn[this.itemCheckedIndex].content;
              break;
          }

          this.view_ai = false;
        }

        if(this.itemCheckedIndex == null){
          Swal.fire(
            '生成文案',
            '請選擇要使用的文案',
            "warning"
          );
        }
      } else {
        Swal.fire(
          '生成文案',
          '請先產生文案。',
          "warning"
        );
      }
    },
    editAiPicture(){
      this.showAiPictureModal = true;
    },
    onImageUpload(event) {
      console.log('onImageUpload');
      this.fileUpload = event.target.files[0];
      const file = event.target.files[0];
      if (file) {
        this.fileName = file.name;

        const reader = new FileReader();
        console.log('reader');
        console.log(reader);
        reader.onload = (e) => {
          this.imageFile = e.target.result;

          console.log('this.imageFile');
          console.log(this.imageFile);
        };
        reader.readAsDataURL(file);

        if (this.fileUpload) {
          // 检查 MIME 类型
          this.showVideoLoading = false;
          const mimeType = this.fileUpload.type;
          console.log('mimeType');
          console.log(mimeType);
          if (mimeType === 'image/png' || mimeType === 'image/jpeg') {
            let formData = new FormData();
            formData.append('image', this.fileUpload);
            formData.append('adaccount_id', this.$route.params.adaccount_id);
            formData.append('s_code', this.$route.params.id);

            axios
              .post('https://test.autoturn.net/inside/api/adimage_update.php', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
              .then((response) => {
                console.log('adimage_update response');
                console.log(response);
                if(response.data.status == 'success'){
                  Swal.fire(
                    '選擇圖像/影片-上傳素材圖片',
                    '上傳完成。',
                    "success"
                  );

                  this.materialUpdate();
                } else {
                  Swal.fire(
                    '選擇圖像/影片-上傳素材圖片',
                    '上傳失敗，請與客服確認問題，並提供要上傳的檔案。',
                    "error"
                  );
                }

                event.target.value = "";
                this.fileUpload = null;
                this.fileName = '';
                this.imageFile = null;
                this.showVideoLoading = true;
              })
              .catch((error) => {
                console.error('Upload request error:', error);
                this.showVideoLoading = true;
              });;
          } else {
            Swal.fire(
              '選擇圖像/影片-上傳素材圖片',
              '限上傳jpg、png圖檔。',
              "error"
            );

            this.showVideoLoading = true;
          }
        }
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    onFilesSelected(event) {
      const newFiles = Array.from(event.target.files);

      newFiles.forEach((file) => {
        const exists = this.selectedFiles.some((f) => f.name === file.name);

        if (!exists) {
          const previewUrl = URL.createObjectURL(file);
          this.selectedFiles.push({ file, name: file.name, previewUrl });
        }
      });

      event.target.value = null;
    },
    removeFile(index) {
      const file = this.selectedFiles[index];
      URL.revokeObjectURL(file.previewUrl);
      this.selectedFiles.splice(index, 1);
    },
    async uploadImages() {
      if (this.selectedFiles.length === 0) {
        Swal.fire(
          '多圖上傳至廣告帳戶',
          '請選擇要上傳的圖片。',
          "info"
        );
        return;
      }

      this.isUploading = true;
      this.uploadResults = [];

      // for (const fileObj of this.selectedFiles) {
      for (let i = 0; i < this.selectedFiles.length; i++) {
        const fileObj = this.selectedFiles[i];

        try {
          const formData = new FormData();
          formData.append("image", fileObj.file);
          formData.append('adaccount_id', this.$route.params.adaccount_id);
          formData.append('s_code', this.$route.params.id);

          const response = await axios.post("https://test.autoturn.net/inside/api/adimage_update.php", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          this.uploadResults.push({
            fileName: fileObj.name,
            previewUrl: fileObj.previewUrl,
            success: response.data.status === "success",
          });
        } catch (error) {
          console.error("上傳失敗：", error);
          this.uploadResults.push({
            fileName: fileObj.name,
            previewUrl: fileObj.previewUrl,
            success: false,
          });
        }

        this.selectedFiles.splice(i, 1);
        i--;
      }

      this.selectedFiles = [];
      this.isUploading = false;
      this.useUpload = true;
    },
    triggerFileInputVideo() {
      this.$refs.fileVideoInput.click();
    },
    onVideoFilesSelected(event) {
      const newFiles = Array.from(event.target.files);

      newFiles.forEach((file) => {
        const exists = this.selectedVideoFiles.some((f) => f.name === file.name);

        if (!exists) {
          // const previewUrl = URL.createObjectURL(file);
          this.selectedVideoFiles.push({ file, name: file.name });
        }
      });

      event.target.value = null;
    },
    removeVideoFile(index) {
      const file = this.selectedVideoFiles[index];
      this.selectedVideoFiles.splice(index, 1);
    },
    async uploadVideo() {
      if (this.selectedVideoFiles.length === 0) {
        Swal.fire(
          '上傳影片至廣告帳戶',
          '請選擇要上傳的影片。',
          "info"
        );
        return;
      }

      this.videoIsUploading = true;
      this.uploadVideoResults = [];

      // for (const fileObj of this.selectedVideoFiles) {
      for (let i = 0; i < this.selectedVideoFiles.length; i++) {
        const fileObj = this.selectedVideoFiles[i];

        try {
          const formData = new FormData();
          formData.append("image", fileObj.file);
          formData.append('adaccount_id', this.$route.params.adaccount_id);
          formData.append('s_code', this.$route.params.id);

          const response = await axios.post("https://test.autoturn.net/inside/api/advideo_update.php", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          this.uploadVideoResults.push({
            fileName: fileObj.name,
            success: response.data.status === "success",
          });
        } catch (error) {
          console.error("上傳失敗：", error);
          this.uploadVideoResults.push({
            fileName: fileObj.name,
            success: false,
          });
        }

        this.selectedVideoFiles.splice(i, 1);
        i--;
      }

      this.selectedVideoFiles = [];
      this.videoIsUploading = false;
      this.useVideoUpload = true;
    },
  },
  computed: {
    moreWording() {
      return this.moreInput ? "隱藏" : "顯示";
    },
    showAddModal: {
      get: function () {
        return this.showAdd
      },
      set: function (value) {
        this.$emit('update:showAdd', value)
      }
    },
    editPageType: {
      get: function () {
        return this.editPage
      },
      set: function (value) {
        this.$emit('update:editPageType', value)
      },
    },
    viewDatalistData: {
      get: function () {
        return this.viewDatalist
      },
      set: function (value) {
        this.$emit('update:viewDatalistData', value)
      },
    },
    returnCampaignObjectiveData: {
      get: function () {
        return this.returnCampaignObjective
      },
      set: function (value) {
        this.$emit('update:returnCampaignObjectiveData', value)
      },
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep(.tab) {
  .p-tabview .p-tabview-nav {
    display: none;
  }

  .p-tabview .p-tabview-panels {
    padding: 0px;
  }
}


.upload-multiple-container {
  /*max-width: 500px;*/
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #f9f9f9;
}

.title {
  text-align: center;
  font-size: 1.5em;
  margin-bottom: 20px;
}

.actions {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-bottom: 20px;
}

.custom-upload-btn,
.upload-btn {
  padding: 10px 20px;
  font-size: 1em;
  border-radius: 5px;
  border: none;
  cursor: pointer;
}

.custom-upload-btn {
  background-color: #007bff;
  color: white;
}

.upload-btn {
  background-color: #28a745;
  color: white;
}

.hidden {
  display: none;
}

.preview-list {
  margin-top: 20px;
}

.preview-image {
  max-width: 100px;
  max-height: 100px;
  object-fit: cover;
  margin-right: 10px;
}

.file-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.file-name {
  flex: 1;
  word-wrap: break-word;
}

.remove-btn {
  background-color: #dc3545;
  color: white;
  padding: 5px 10px;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}

.upload-results {
  margin-top: 20px;
}
</style>